module.exports = {
    lessThanDate: function (date_from,date_inputs) {
        let time_from =date_inputs[0];
        let date_time_end = moment(date_inputs[1]);
        let date_time_start = moment(new Date(date_from+" "+time_from));
        if (date_time_start < date_time_end) {
            return true;
        }
        return 'Start time cannot be equal to or exceed the end time.';
    },
    greaterThanDate_if: function (date_from,date_inputs) {
        otherFieldVal = date_inputs[0].toString()
        let time_from =date_inputs[1];
        let date_time_end = moment(date_inputs[2]);
        let critiriaOptions = date_inputs.slice(3)
        if(critiriaOptions.includes(otherFieldVal)){
            let date_time_start = moment(new Date(date_from+" "+time_from));
            if (date_time_start < date_time_end) {
                return false;
            }
        }
        return true
    },
    pastDate_if(selectedDate,params) {
        otherFieldVal = params[0].toString()
        let selectedTime = params[1]
        let date_time = moment(selectedDate + " "+selectedTime);
        let critiriaOptions = params.slice(2)
        if(critiriaOptions.includes(otherFieldVal)){
            if(date_time>moment())
                return false
        }
        return true
    },
}